import { WINDOW_RESIZE } from '../types';

const resizeWindow = sizes => dispatch => dispatch({ type: WINDOW_RESIZE, payload: sizes });

export { resizeWindow };
